/**
 * Drizzle query builders + query keys de la ESPINA de módulos (F2-A).
 * Consumo local-first (streams de curso extendidos con course_module /
 * course_settings / resource). Escritura vía write-path (authz autor/editor).
 */

import {
  and,
  asc,
  course_module,
  course_settings,
  eq,
  isNull,
  type PowerSyncDrizzleDB,
  resource,
} from "@space/powersync";

export const moduleQueryKeys = {
  all: ["academy-modules"] as const,
  byCourse: (courseId: string | undefined) => ["academy-modules", "course", courseId] as const,
  settings: (courseId: string | undefined) => ["academy-modules", "settings", courseId] as const,
  resources: (courseId: string | undefined) => ["academy-modules", "resources", courseId] as const,
};

/** Módulos (espina) de un curso, ordenados por unidad y posición. */
export function getCourseModulesQuery(db: PowerSyncDrizzleDB, courseId: string) {
  return db
    .select()
    .from(course_module)
    .where(and(eq(course_module.course_id, courseId), isNull(course_module.deleted_at)))
    .orderBy(asc(course_module.position), asc(course_module.created_at));
}

/** Ajustes (singleton) de un curso. id = course_id. */
export function getCourseSettingsQuery(db: PowerSyncDrizzleDB, courseId: string) {
  return db.select().from(course_settings).where(eq(course_settings.id, courseId)).limit(1);
}

/** Recursos activos de un curso. */
export function getCourseResourcesQuery(db: PowerSyncDrizzleDB, courseId: string) {
  return db
    .select()
    .from(resource)
    .where(and(eq(resource.course_id, courseId), isNull(resource.deleted_at)))
    .orderBy(asc(resource.created_at));
}
